import styled from 'styled-components';

export const SettingsDeleteProfileStyled = styled.div`
    flex: 1;
    flex-direction: column;
    display: flex;
    
    .btn {
        color: var(--color-negative);
    }
`;
